// Lib imports
import React, { useContext } from 'react';
import { Box, TextInput, Button, Text, Select, ThemeContext } from 'grommet';
import { Formik } from 'formik';
import * as Yup from 'yup';
import PropTypes from 'prop-types';

// Core imports
import FormField from 'granite-admin/core/components/FormField';
import ONBOARDING_MESSAGES from 'granite-admin/messages/onBoarding';
import PhoneInput from 'granite-admin/core/components/PhoneInput/v2';
import { useToast } from 'granite-admin/core/components/Toast';
import useRouteChange from 'granite-admin/utils/useRouteChange';
// Application imports
// import ONBOARDING_EVENTS from './../constants'

const LoginForm = ({
  eventEmitter,
  onSubmit: submitClicked,
  companyTypesList,
  userProfile
}) => {
  const {
    errorToast
  } = useToast();
  const {
    prefillEmail = true
  } = useContext(ThemeContext) ?? {};
  // const size = useContext(ResponsiveContext);
  // FIXME: Move strings to messages
  useRouteChange({});
  const validationSchema = Yup.object().shape({
    name: Yup.string().required('Company Name is required'),
    email: Yup.string().min(2, 'Email too short').max(50, 'Email too long').email('Invalid email address').required('Email is required'),
    phone: Yup.object().shape({
      number: Yup.string().required('Phone Number is required').min(10, 'Phone Number is too short').max(17, 'Phone Number is too long')
    }),
    industry: Yup.string().nullable().required('Type is required')
  });
  const onSubmit = async (values, {
    setSubmitting,
    setErrors
  }) => {
    setErrors({});
    setSubmitting(true);
    try {
      await submitClicked(eventEmitter, values);
    } catch ({
      errors
    }) {
      // catch (e) {
      //   if (e.errors) setErrors(e.errors);
      // }
      if (errors) {
        setErrors(errors);
        console.log(errors);
        let errorMessage = errors.api_error || errors.title || errors.field_error;
        if (errorMessage) {
          errorToast(errorMessage);
        }
      }
    }
    setSubmitting(false);
  };
  return /*#__PURE__*/React.createElement(Formik, {
    initialValues: {
      name: '',
      email: prefillEmail ? userProfile.email : '',
      industry: '',
      phone: undefined
    },
    validationSchema: validationSchema,
    onSubmit: onSubmit
  }, ({
    values,
    errors,
    touched,
    handleChange,
    handleBlur,
    handleSubmit,
    setFieldValue,
    isSubmitting,
    setFieldTouched
  }) => {
    return /*#__PURE__*/React.createElement("form", {
      onSubmit: handleSubmit
    }, /*#__PURE__*/React.createElement(FormField, {
      name: "name",
      label: ONBOARDING_MESSAGES.NAME_LABEL,
      error: touched.name && errors.name
    }, /*#__PURE__*/React.createElement(TextInput, {
      name: "name",
      onChange: handleChange,
      onBlur: handleBlur,
      value: values.name
    })), /*#__PURE__*/React.createElement(Box, {
      width: "100%",
      direction: "row-responsive",
      gap: "xsmall"
    }, /*#__PURE__*/React.createElement(FormField, {
      basis: "90%",
      name: "phone",
      label: ONBOARDING_MESSAGES.PHONE_LABEL,
      error: touched.phone && errors.phone?.number
    }, /*#__PURE__*/React.createElement(PhoneInput, {
      inputProps: {
        name: 'phone'
      },
      onChange: phone => setFieldValue('phone', {
        ...phone
      }),
      onBlur: handleBlur,
      value: values.phone
    })), /*#__PURE__*/React.createElement(FormField, {
      basis: "90%",
      name: "email",
      label: ONBOARDING_MESSAGES.EMAIL_LABEL,
      error: touched.email && errors.email
    }, /*#__PURE__*/React.createElement(TextInput, {
      name: "email",
      onChange: handleChange,
      onBlur: handleBlur,
      value: values.email
    }))), !process.env.REACT_APP_COMPANY_TYPE && /*#__PURE__*/React.createElement(Box, {
      width: "100%",
      direction: "row-responsive"
    }, /*#__PURE__*/React.createElement(FormField, {
      basis: "66%",
      name: "industry",
      label: ONBOARDING_MESSAGES.COMPANY_TYPE_LABEL,
      error: touched.industry && errors.industry
    }, /*#__PURE__*/React.createElement(Select, {
      options: companyTypesList,
      name: "industry",
      value: values.industry,
      onChange: async ({
        value
      }) => {
        await setFieldValue('industry', value);
        if (!touched.industry) setFieldTouched('industry', true, false);
      },
      onBlur: e => !touched.industry && setFieldTouched('industry', true)
    }))), /*#__PURE__*/React.createElement(Button, {
      type: "submit",
      alignSelf: "start",
      margin: {
        vertical: 'medium'
      },
      label: isSubmitting ? ONBOARDING_MESSAGES.SUBMIT_BUTTON_LABEL_SUBMITTING : ONBOARDING_MESSAGES.SUBMIT_BUTTON_LABEL,
      disabled: isSubmitting,
      primary: true,
      color: "secondary"
    }), /*#__PURE__*/React.createElement(Text, {
      as: "div",
      color: "status-critical"
    }, errors.non_field));
  });
};
LoginForm.propTypes = {
  onSubmit: PropTypes.func,
  eventEmitter: PropTypes.object,
  userProfile: PropTypes.object,
  companyTypesList: PropTypes.array
};
export default LoginForm;